import React, { useState, useEffect, Fragment } from "react";
import {TextField, CircularProgress} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';
import { useHistory } from "react-router-dom";
import useStyles from './styles'
import ttAPI from '../../api/ttAPI'
import './SelectRetest.css'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';


export default function SelectRetest(props) {
  const { onSelect, labelName } = props
  const classes = useStyles();
  const history = useHistory();
  const [retestSearchedList, setRetestSearchedList] = useState([]);
  const [selectedRetestValue, setSelectedRetestValue] = useState({});
  const [retestInputValue, setRetestInputValue] = useState('');
  const [isSearchRetestOpen, setIsSearchRetestOpen] = useState(false);

  useEffect( () => {
    async function fetchData() {
      const response = await ttAPI.searchRetests(retestInputValue);
      setRetestSearchedList(response === null ? [] : response);
    }
    if (retestInputValue !== undefined && retestInputValue !== '' && retestInputValue.length >= 3) {
      fetchData();
    }
  }, [retestInputValue]);


  useEffect(() => {
    if (!isSearchRetestOpen) {
      setRetestSearchedList([]);
    }
  }, [isSearchRetestOpen]);

  function onRetestSelected(newValue) {
    history.push({pathname:`/app/retest/book/${newValue.id}`,
                 state:{retestId: newValue.id}
               });
    if (window.location.href.indexOf('/app/retest/book/') > -1) {
      window.location.reload();
    }
  }

   // note: for getOptionSelected: if you return false for no match then there will be a warning in the console complain the input does not match what's in the options}
  return (
<div className={classes.contentDiv}>
    <Autocomplete
      id="search-retest"
      className={classes.autocomplete}
      ListboxProps={{ style: { top: '164px', maxHeight: "calc(90vh)"}, position: "bottom-start" }}
      getOptionSelected={(option, value) => {
        if (value === '') {
          return true;
        }
        return Object.keys(option).length === 0 || Object.keys(value).length === 0 ? true : option.name === value.name;}
      }
      getOptionLabel={(option) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }
        return Object.keys(option).length === 0 ? '' : `${option.name} - ${option.site_name} - ${option.ex_month}(${option.assets})`;
      }}
      renderOption={(option, state) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }

        const matches = match(option.customer_name, retestInputValue);
        const parts = parse(option.customer_name, matches);

        const matchesSiteName = match(option.site_name, retestInputValue);
        const partsSite = parse(option.site_name, matchesSiteName);

        return (
        <Fragment key={option.id}>
          <div className={classes.option}>
          <span className={classes.optionSpan}>
            {parts.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
            <span className={classes.optionSpan}>
            {partsSite.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
            <span className={classes.optionSpan}>{option.expiry_month}({option.site_total_assets})</span>
          </div>
        </Fragment>
      );
      }}
      filterOptions={(options, state) => {/*need to keep this function here for phrase matching*/ return options;}}
      options={retestSearchedList}
      noOptionsText="No Result"
      onChange={(event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          setSelectedRetestValue(newValue);
          onRetestSelected(newValue);
        }
      }}
      open={isSearchRetestOpen}
      onOpen={() => {
        setIsSearchRetestOpen(true);
      }}
      onClose={() => {
        setIsSearchRetestOpen(false);
      }}
      inputValue={retestInputValue}
      value={selectedRetestValue}
      onInputChange={(event, newInputValue,reason) => {
          setRetestInputValue(newInputValue);
      }}
      size="small"
      renderInput={(params) => <TextField
                                {...params}
                                style={{ backgroundColor: 'white' }}
                                placeholder={labelName}
                                variant="outlined"
                                  />}
      />
      </div>
  );
}
